import LegalPage from '@/components/feature/LegalPage';
import { privacyPolicy } from '@/data/legal/privacyPolicy';

export default function PrivacyPolicy() {
  return <LegalPage doc={privacyPolicy} />;
}